import req from '../../api/request'
import type { MyInvitation } from './types'

/**
 * GET /invitations — the signed-in person's own invitations, accepted ones
 * included: the list mobile Home reads too. The endpoint wraps it in `data`.
 */
export const getMyInvitations = async (): Promise<MyInvitation[]> => {
  const response = (await req('/invitations')) as {
    data?: MyInvitation[]
  } | null

  return response?.data ?? []
}
